const complexion = [
  { label: "Black Ethnic Complexion", value: "Black Ethnic Complexion" },
  { label: "White Ethnic Complexion", value: "White Ethnic Complexion" },
  { label: "Very Fair", value: "Very Fair" },
  { label: "Fair", value: "Fair" },
  { label: "Wheatish / Light Brown", value: "Wheatish / Light Brown" },
  { label: "Dark", value: "Dark" },
];
export default complexion;
